<div class="circle" [style]="{'background-color':  circleColor }">
  @if (!showInitials) {
    <img src="{{photoUrl}}">
  }

  @if (showInitials) {
    <div class="initials">
      {{ initials }}
    </div>
  }
</div>